module.exports = __webpack_public_path__ + "media/top/main_visual_features-46ae31eb.svg";